import { Field } from 'formik';
import { TextField } from 'formik-mui';

export const OkvedPartitionForm = () => {

  return (
    <>
      <Field component={TextField} name="partitionCode" label="Код раздела" placeholder="Код раздела" required/>           
      <Field component={TextField} name="name" label="Наименование раздела" required/>
    </>
  );
};
  

export default OkvedPartitionForm;
